import { SNOWPLOW } from '@docsapp/constants';

export const SNOWPLOW_EVENTS_NAME = {
    HRWIN_PAGE_OPEN: 'HRWIN_PAGE_OPEN',
    HRWIN_LOGIN_ATTEMPTED: 'HRWIN_LOGIN_ATTEMPTED',
    HRWIN_LOGGED_IN: 'HRWIN_LOGGED_IN',
    HRWIN_OTP_SCREEN: 'HRWIN_OTP_SCREEN',
    HRWIN_SECTION_SELECTED: 'HRWIN_SECTION_SELECTED'
}

export const SNOWPLOW_EVENTS_SCHEMA = {
    HRWIN_PAGE_OPEN: 'iglu:com.medibuddy/HRWIN_PAGE_OPEN/jsonschema/1-0-0',
    HRWIN_LOGIN_ATTEMPTED: 'iglu:com.medibuddy/HRWIN_LOGIN_ATTEMPTED/jsonschema/1-0-0',
    HRWIN_LOGGED_IN: 'iglu:com.medibuddy/HRWIN_LOGGED_IN/jsonschema/1-0-0',
    HRWIN_OTP_SCREEN: 'iglu:com.medibuddy/HRWIN_OTP_SCREEN/jsonschema/1-0-0',
    HRWIN_SECTION_SELECTED: 'iglu:com.medibuddy/HRWIN_SECTION_SELECTED/jsonschema/1-0-0'
}

export const EVENT_PLATFORMS = {
    HRWIN_PAGE_OPEN: [SNOWPLOW],
    HRWIN_LOGIN_ATTEMPTED: [SNOWPLOW],
    HRWIN_LOGGED_IN: [SNOWPLOW],
    HRWIN_OTP_SCREEN: [SNOWPLOW],
    HRWIN_SECTION_SELECTED: [SNOWPLOW]
}

export const PLATFORM_WEB = 'web';
export const HR_WIN_SERVICE_NAME = 'HRWIN';

export const EVENT_KEYS = {
    PLATFORM: 'platform',
    TIMESTAMP: 'timestamp',
    EMAIL:'email',
    USERNAME:'username',
    SECTION_TYPE:'section_type',
    SECTION_NAME:'section_name',
    MB_USER_ID:'mbuserid',
    ENTITY_ID:'pmentityid'

}
    